import { struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

export const Params = struct({
	id: iotsUtils.NotEmptyString,
});
